import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum GroupingTagActionEnum {
	Delete = 'delete',
}

export type GroupingTagConfirmationModalData = {
	groupingTagId: string | Array<string>;
	element: string;
	action: GroupingTagActionEnum;
};

@Component({
	selector: 'app-grouping-tag-action-confirm-popup',
	templateUrl: './grouping-tag-action-confirm-popup.component.html',
	styleUrls: ['./grouping-tag-action-confirm-popup.component.scss'],
})
export class GroupingTagActionConfirmPopupComponent<
	T extends GroupingTagConfirmationModalData
> extends DcBaseComponent {
	protected readonly GroupingTagAction = GroupingTagActionEnum;
	protected readonly DcIcons = DcIcons;

	public vo$: Observable<{
		element: string;
		groupingTagId: string | Array<string>;
		action: GroupingTagActionEnum;
		isMultipleElement: boolean;
	}>;
	public confirmDeletion = false;

	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'grouping-tag-action-confirm-popup';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement: Array.isArray(this.modalData.groupingTagId),
			groupingTagId: this.modalData.groupingTagId,
			action: this.modalData.action,
		});
	}

	public launchAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
